/**
 * @generated SignedSource<<fd4b48a1ec4d70df1b2a01a898a54b15>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type NativeIssueTableWithSelectedIssuesProvider527BadPattern$data = {
  readonly " $fragmentSpreads": FragmentRefs<"FooterRenderer195BadPattern" | "IssueTable807BadPattern">;
  readonly " $fragmentType": "NativeIssueTableWithSelectedIssuesProvider527BadPattern";
};
export type NativeIssueTableWithSelectedIssuesProvider527BadPattern$key = {
  readonly " $data"?: NativeIssueTableWithSelectedIssuesProvider527BadPattern$data;
  readonly " $fragmentSpreads": FragmentRefs<"NativeIssueTableWithSelectedIssuesProvider527BadPattern">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "NativeIssueTableWithSelectedIssuesProvider527BadPattern",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "IssueTable807BadPattern"
    },
    {
      "kind": "FragmentSpread",
      "name": "FooterRenderer195BadPattern"
    }
  ],
  "type": "JiraJqlFieldWithAliases"
};

(node as any).hash = "bb277f8ae370eafe3d5f3a8a09ca24c1";

export default node;
